import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

const ResumenFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Col md={5}/>
      <Col md={7}>
        <Field name='resumen'>
          {({ field }) => <Form.Checkbox {...field} checked={iValue} disabled={fIsSubmitting} id='resumen' label='Resumen por Dia' />}
        </Field>
      </Col>
    </Form.Group>
  )
}

export default React.memo(ResumenFormGroup)
